module.exports = __webpack_public_path__ + "assets/ic_character4.fbfdf502.svg";